import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-filters',
  templateUrl: './our-filters.component.html',
  styleUrls: ['./our-filters.component.css']
})
export class OurFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
